import { render, staticRenderFns } from "./AddToCalendarButton.vue?vue&type=template&id=87315b40&scoped=true"
import script from "./AddToCalendarButton.vue?vue&type=script&lang=ts"
export * from "./AddToCalendarButton.vue?vue&type=script&lang=ts"
import style0 from "./AddToCalendarButton.vue?vue&type=style&index=0&id=87315b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87315b40",
  null
  
)

export default component.exports